module.exports = __webpack_public_path__ + "static/media/10.ea034f5a.jpg";